import { useState, useEffect } from 'react';
import { Browser } from '../../services/helpers/Browser';



const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState({
        isMobile: Browser.isTablet(),
        isPWApp: Browser.isPWApp(),
        isMobNativeApp: Browser.isMobNativeApp(),
        isLandscape: Browser.isLandscape(),
        deviceCategory: Browser.getDeviceType(),
        viewportHeight: window.innerHeight,
        viewportWidth: window.innerWidth
    });

    useEffect(() => {
        const updateDeviceType = () => {
            setTimeout(() => {
                setDeviceType({
                    isMobile: Browser.isTablet(),
                    isPWApp: Browser.isPWApp(),
                    isMobNativeApp: Browser.isMobNativeApp(),
                    isLandscape: Browser.isLandscape(),
                    deviceCategory: Browser.getDeviceType(),
                });
            }, 10) // made async. we use navigator.useragent in api calls so it stays the old when we do it sync.
        };

        window.addEventListener("resize", updateDeviceType);
        window.addEventListener("orientationchange", updateDeviceType);

        return () => {
            window.removeEventListener("resize", updateDeviceType);
            window.removeEventListener("orientationchange", updateDeviceType);
        };
    }, []);

    return deviceType;
};

export default useDeviceType;
